<CardBase {element}>
  <div class="chat-log" bind:this={wrapperDiv}>
    {#if chatStickyLog.length > 0}
      <div class="sticky-area">
        {#each chatStickyLog as msg (msg.Id)}
          <ChatLogItem {msg} />
        {/each}
      </div>
    {/if}
    <div class="normal-area">
      {#each chatLog.filter(e => !e.Sticky) as msg (msg.Id)}
        <ChatLogItem {msg} />
      {/each}
    </div>
  </div>
</CardBase>

<style type="text/scss">*, *:before, *:after {
  box-sizing: border-box;
}

.chat-log-sticky {
  position: absolute;
  top: 0;
  left: 0;
  padding: 6px 20px 6px 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  background-color: #fff;
  color: #000000;
}

.chat-log-sticky.admin {
  flex-direction: row-reverse;
  background-color: #c60033;
  color: var(--f7-theme-color-bg-color);
}

.chat-log {
  width: 100%;
  height: calc(100vh - 54px - calc(100vw*9/16)) !important;
  overflow: auto;
  /*padding: 0 0 60px 0;*/
  /*padding: 0;*/
  padding-bottom: 60px;
  background-color: #fff;
  background-image: url("../../../../../static/images/yellowbg.jpg");
  background-size: cover;
  background-position: center;
}

.sticky-area {
  background: white;
  padding: 10px 20px;
  overflow: auto;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  box-shadow: 0px 2px 20px -2px #440000;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  z-index: 10;
}

.sticky-area :global(.chat-log-entry) {
  background: transparent !important;
  color: black;
  flex-direction: row-reverse;
  padding: 0;
}

.sticky-area :global(.chat-log-entry-icon-col) {
  padding: 0 0 0 7px;
}

.normal-area {
  padding: 20px;
}</style>

<script lang="ts">//import { myMessages } from '../common/index';
import "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { findSourceStore } from "../../../utilities";
import "svelte/store";
import "../../../common/CardsDataSourceRegistration";
import { afterUpdate, beforeUpdate, onMount } from 'svelte';
import ChatLogItem from './ChatLogItem.svelte';
export let element;
export let sources;
export let sourceStore;
let wrapperDiv;
let scrollParent;
let prevScrollHeight = 0;
let autoScroll = false;
let initialScroll = false;
let chatStickyLog = [];
$: {
    sourceStore = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
}
;
$: data = (sourceStore && $sourceStore) ? $sourceStore : null;
$: chatLog = [].concat(data === null || data === void 0 ? void 0 : data.ChatLogItem).filter(item => item === null || item === void 0 ? void 0 : item.Id);
$: {
    chatStickyLog = chatLog.filter(e => e.Sticky);
    chatStickyLog.splice(0, chatStickyLog.length - 1);
}
beforeUpdate(() => {
    if (scrollParent) {
        if (prevScrollHeight !== scrollParent.scrollHeight && prevScrollHeight < scrollParent.scrollHeight) {
            prevScrollHeight = scrollParent.scrollHeight;
            autoScroll = true;
        }
        else {
            autoScroll = scrollParent.scrollHeight - scrollParent.clientHeight <= scrollParent.scrollTop + 20;
        }
    }
});
afterUpdate(() => {
    let timeout = 50;
    if (!initialScroll && scrollParent.scrollHeight > scrollParent.clientHeight) {
        initialScroll = true;
        autoScroll = true;
        timeout = 1000; // longer timeout on initial load because page is loading
    }
    if (scrollParent && autoScroll) {
        setTimeout(() => {
            scrollParent.scrollTo(0, scrollParent.scrollHeight);
        }, timeout);
    }
});
// TODO: Should move this logic into a common parent element and pass down the scroll container through props.
onMount(() => {
    if (wrapperDiv) {
        scrollParent = wrapperDiv;
    }
});
</script>